import React from 'react';
import { FormControl, TextField } from '@material-ui/core';

import { MileageControlProps } from './MileageControl.interfaces';
import { ControlContainer } from 'app/components/ControlContainer';
import { DoneAdornment } from 'app/components/DoneAdornment';
import { useMileageControl } from 'app/shared/hooks/controls/useMileageControl';
import { useStyles } from './MileageControl.styles';
import { UtilService } from 'app/services/util.service';
import { Caption } from 'app/components/Caption';

export default function MileageControl(props: MileageControlProps) {
  const classes = useStyles();

  const {
    helperText,
    inlineTooltip,
    input,
    input: { value },
    label,
    meta,
    tooltip,
  } = props;

  const {
    error,
    focused,
    handleBlur,
    handleChange,
    handleClick,
    isValueCheckVisible,
    onFocus,
  } = useMileageControl(props);

  const renderCaption = () =>
    inlineTooltip && (focused || value) ? (
      <Caption
        classes={{
          root: classes.caption,
        }}
        text={inlineTooltip}
      />
    ) : null;

  return (
    <FormControl fullWidth>
      <ControlContainer
        inputId={input.name}
        floating
        tooltip={tooltip}
        floated={focused || UtilService.hasValue(input.value)}
        helperText={helperText}
        meta={meta}
        focused={focused}
      >
        <TextField
          {...input}
          id={input.name}
          onChange={handleChange}
          onBlur={handleBlur}
          onClick={handleClick}
          onFocus={onFocus}
          className={classes.control}
          InputLabelProps={{
            shrink: UtilService.hasValue(input.value) || focused,
          }}
          InputProps={{
            startAdornment: isValueCheckVisible && <DoneAdornment />,
          }}
          error={error}
          variant={'outlined'}
          margin={'dense'}
          label={label}
          type="tel"
        />
        {renderCaption()}
      </ControlContainer>
    </FormControl>
  );
}
